module.exports = __webpack_public_path__ + "static/media/README.ad06d63c.md";